export { default } from './MainPaywallLayout';
